import { render, staticRenderFns } from "./FormCategory.vue?vue&type=template&id=51159bc0&"
import script from "./FormCategory.vue?vue&type=script&lang=js&"
export * from "./FormCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51159bc0')) {
      api.createRecord('51159bc0', component.options)
    } else {
      api.reload('51159bc0', component.options)
    }
    module.hot.accept("./FormCategory.vue?vue&type=template&id=51159bc0&", function () {
      api.rerender('51159bc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/category/form/FormCategory.vue"
export default component.exports